// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Kgdq","ranges":"BmiRanges_ranges__3lZYO"};